<template>
  <footer id="footer">
    <v-spacer size="100px"></v-spacer>
    <div class="container" style="position: relative; z-index: 2;">
      <h2>Contact Me</h2>
      <v-spacer size="2rem"></v-spacer>
      <p class="bs_centeredOnMobile bs_margin20" style="font-weight: 600;">Yes! I am currently taking on freelance projects for web design & web
        development.</p>
      <p class="bs_centeredOnMobile bs_margin20" style="font-weight: 600;">References are
        available upon request. More details on website development / app projects are also available
        upon request.</p>
      <v-spacer size="2rem"></v-spacer>
      <div class="bs_centeredOnMobile bs_right">
        <a href="mailto:mari@beesgo.co?subject=Let%27s%20work%20together%21" aria-label="email link">
          <div class="icon" style="margin-right: 20px;">
              <svg style="pointer-events: none;" version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                   viewBox="0 0 32 32">
                <title>email</title>
                <path
                  d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM8 8h16c0.286 0 0.563 0.061 0.817 0.177l-8.817 10.286-8.817-10.287c0.254-0.116 0.531-0.177 0.817-0.177zM6 22v-12c0-0.042 0.002-0.084 0.004-0.125l5.864 6.842-5.8 5.8c-0.045-0.167-0.069-0.34-0.069-0.517zM24 24h-16c-0.177 0-0.35-0.024-0.517-0.069l5.691-5.691 2.826 3.297 2.826-3.297 5.691 5.691c-0.167 0.045-0.34 0.069-0.517 0.069zM26 22c0 0.177-0.024 0.35-0.069 0.517l-5.8-5.8 5.865-6.842c0.003 0.041 0.004 0.083 0.004 0.125v12z"></path>
              </svg>
          </div>
        </a>

        <div class="icon">
          <a href="https://www.linkedin.com/in/mari-garibov/" rel="noreferrer" target="_blank" aria-label="linkedin link">
            <span>
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                   viewBox="0 0 32 32">
                <title>linkedin</title>
                <path
                  d="M29 0h-26c-1.65 0-3 1.35-3 3v26c0 1.65 1.35 3 3 3h26c1.65 0 3-1.35 3-3v-26c0-1.65-1.35-3-3-3zM12 26h-4v-14h4v14zM10 10c-1.106 0-2-0.894-2-2s0.894-2 2-2c1.106 0 2 0.894 2 2s-0.894 2-2 2zM26 26h-4v-8c0-1.106-0.894-2-2-2s-2 0.894-2 2v8h-4v-14h4v2.481c0.825-1.131 2.087-2.481 3.5-2.481 2.488 0 4.5 2.238 4.5 5v9z"></path>
              </svg>
            </span>
          </a>
        </div>
      </div>
    </div>
    <canvas id="canvas" style="z-index: 1;"></canvas>
    <v-spacer size="100px"></v-spacer>
  </footer>
</template>

<script>
  import VSpacer from './VSpacer'

  export default {
    components: {
      VSpacer
    },
    mounted () {
      var canvas = document.getElementById('canvas')
      var ctx = canvas.getContext('2d')
      canvas.width = window.innerWidth
      canvas.height = window.innerHeight
      var particles = []
      var numParticles = 30

      // start with random starting position
      var Particle = function () {
        this.x = canvas.width * Math.random()
        this.y = canvas.height * Math.random()
        this.vx = -1
        this.vy = Math.random()
      }
      // Adding two methods
      Particle.prototype.Draw = function (ctx) {
        ctx.beginPath()
        ctx.fillStyle = 'rgba(255,255,255,0.15)'
        ctx.arc(this.x, this.y, 3, 0, 3 * Math.PI)
        ctx.fill()
      }

      Particle.prototype.Update = function () {
        // set the starting x/y to have velocity
        this.x += this.vx
        this.y += this.vy

        if (this.x < 0) {
          this.x = canvas.width // resets back to beginning
        }
        if (this.y < 0 || this.y > canvas.height) { // when it hits the top or bottom bounce
          this.vy = -this.vy
        }
      }

      function loop () {
        ctx.clearRect(0, 0, canvas.width, canvas.height)

        for (var i = 0; i < numParticles; i++) {
          particles[i].Update()
          particles[i].Draw(ctx)
        }
        requestAnimationFrame(loop)
      }

      // Create particles
      for (var i = 0; i < numParticles; i++) {
        particles.push(new Particle())
      }
      loop()
    }
  }
</script>
